export default __webpack_public_path__ + "static/media/avax-logo.30dfa545.png";